import { createWithRemoteLoader } from '@kne/remote-loader';
import { Col, Row, Space } from 'antd';
import get from 'lodash/get';
import style from './style.module.scss';

const ExpectSalary = createWithRemoteLoader({
  modules: ['components-core:FormInfo']
})(({ name, groupLabel, label, rule, remoteModules }) => {
  const [FormInfo] = remoteModules;
  const { InputNumber } = FormInfo.fields;
  return (
    <Space direction={'vertical'} size={2}>
      <div className={style['expect-salary']}>{groupLabel}</div>
      <Row wrap={false} className={style['expect-salary-input']}>
        <Col flex={1}>
          <InputNumber name={get(name, '0', 'salaryMin')} label={get(label, '0', '最低薪资')} rule={get(rule, '0')} labelHidden />
        </Col>
        <Col className={style['split']}>~</Col>
        <Col flex={1}>
          <InputNumber name={get(name, '1', 'salaryMax')} label={get(label, '1', '最高薪资')} rule={get(rule, '1')} labelHidden addonAfter="K" />
        </Col>
      </Row>
    </Space>
  );
});

ExpectSalary.defaultProps = {
  groupLabel: '期望月薪'
};

export default ExpectSalary;
